import { z } from 'zod';
import { EnergyMix } from '../enums';

export const situationSchema = z.object({
  smart_meter: z.boolean(),
  energy_mix: z.nativeEnum(EnergyMix),
  knows_consumption: z.boolean(),
  number_in_household: z.string(),
  solar_panels: z.boolean(),
  heat_pump: z.boolean(),
  electricity_usage_normal: z.number().min(0).nullable(),
  electricity_usage_low: z.number().min(0).nullable(),
  electricity_generation_normal: z.number().min(0).default(0),
  electricity_generation_low: z.number().min(0).default(0),
  gas_usage: z.number().min(0).nullable(),
});

export type ISituationState = z.infer<typeof situationSchema>;
